import { thunk, action, computed } from 'easy-peasy'
import axios from 'axios'
import { MD5 } from 'crypto-js'
import validateForm from '../utils/validateForm'
import getEnvironment from '../../utils/getEnvironment'
import AnalyticsHandler from '../../analytics/analiticsHandler'

export default {
  status: 'init',
  server: {},
  fields: [],
  filledFields: {},
  validationErrors: {},
  generalError: false,
  openModal: false,
  openModalLeave: false,
  popup: false,
  id: null,
  secret: null,
  fbPixel: {},
  config: {},
  isLoading: false,
  validated: null,
  submit: thunk(
    async (
      actions,
      payload,
      { getState, getStoreState, getStoreActions },
    ) => {
      const {
        steps: { nextStep, prevStep },
      } = getStoreActions()
      actions.setStatus('submited')
      actions.setGeneralError(false)
      const {
        fields,
        filledFields,
        fbPixel,
        config,
        server: {
          endpoint: { [getEnvironment()]: endpoint },
          errors,
        },
      } = getState()

      const { locale } = getStoreState().locale
      const { scanPoints } = getStoreState()

      const validation = validateForm(fields, filledFields, locale)
      actions.setValidationErrors(validation)

      if (config.gtmConsumer && validation.email) {
        AnalyticsHandler.getEventError(
          config.eventCategory,
          validation,
          false,
        )
      }

      if (
        Object.keys(validation).length === 0 &&
        validation.constructor === Object
      ) {
        try {
          const formData = fields.reduce(
            (response, { name, type, ignore }) => {
              if (!ignore && type !== 'Title' && filledFields[name])
                response[name] = filledFields[name]
              return response
            },
            {},
          )
          config.multiSteps && nextStep()
          actions.setPopup(true)

          const { data } = await axios.post(endpoint, formData)
          if (data.success) {
            actions.setValidated(data.validated)
            window.location.href = '#form'
          }
          actions.setId(data)

          if (config.gtmConsumer) {
            AnalyticsHandler.getSubscriptionEvent(
              config.eventCategory,
              config.eventAction,
              filledFields.newsletter !== 'undefined',
              scanPoints,
              MD5(filledFields.email.toLowerCase()).toString(),
            )
          }
          /*eslint-disable */
          // GTM event
          if (config.gtm) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: config.event || 'analyticsEvent',
              eventData: {
                category:
                  config.category ||
                  window.location.pathname + window.location.search,
                action: 'start_poll',
                label:
                  typeof filledFields.newsletter !== 'undefined'
                    ? 'yes'
                    : 'no',
              },
            })
          }
          // end GTM event

          // GTM USA event
          if (config.gtmUSA) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: config.event || 'analyticsEvent',
              eventAction: 'start_poll',
              eventCategory:
                config.category ||
                window.location.pathname + window.location.search,
              eventLabel:
                typeof filledFields.newsletter !== 'undefined'
                  ? 'yes'
                  : 'no',
              leadId: MD5(
                filledFields.email.toLowerCase(),
              ).toString(),
            })
          }
          // end GTM USA event

          // facebook pixel
          const { countries, type } = fbPixel
          if (
            fbPixel &&
            countries.includes(locale) &&
            filledFields.newsletter &&
            filledFields.newsletter === 'subscribed'
          ) {
            function waitForFbq(cb) {
              if (typeof fbq !== 'undefined') {
                cb()
              } else {
                setTimeout(function() {
                  waitForFbq(cb)
                }, 100)
              }
            }
            const idFbq =
              locale === 'en-us'
                ? '432237353897161'
                : '922484241151678'
            waitForFbq(function() {
              const pixel = window.document.createElement('img')
              pixel.src = `https://www.facebook.com/tr?id=${idFbq}&ev=${type}&noscript=1`
              pixel.style.width = '1'
              pixel.style.height = '1'
              pixel.style.display = 'none'
              pixel.classList.add('fbq-sun-pixel')
              window.document.body.appendChild(pixel)
            })
          }
          // end facebook pixel
          /* eslint-enable */

          config.multiSteps && nextStep()
        } catch (error) {
          console.log(error)

          if (
            error.response &&
            error.response.status === 409 &&
            error.response.data.code === 'alreadyUsed'
          ) {
            actions.setValidationErrors(errors.alreadyUsed.validation)
            actions.setGeneralError(errors.alreadyUsed.message)
            config.multiSteps && prevStep()
          } else if (
            error.response &&
            error.response.status === 409 &&
            error.response.data.code === 'alreadyRegistered'
          ) {
            actions.setValidationErrors(
              errors.alreadyRegistered.validation,
            )
            actions.setGeneralError(errors.alreadyRegistered.message)
            config.multiSteps && prevStep()
          } else if (
            error.response &&
            error.response.status === 422
          ) {
            if (config.gtmConsumer) {
              AnalyticsHandler.getEventError(
                config.eventCategory,
                error.response,
                true,
              )
            }
            actions.setGeneralError(errors.validation.message)
            config.multiSteps && prevStep()
          } else if (error.entityTooLarge) {
            actions.setValidationErrors(error.validation)
          } else {
            actions.setGeneralError(errors.validation.message)
            config.multiSteps && nextStep()
          }
        }
      }
    },
  ),
  setValidationErrors: action((state, payload) => {
    state.validationErrors = payload
  }),
  setStatus: action((state, payload) => {
    state.status = payload
  }),
  setGeneralError: action((state, payload) => {
    state.generalError = payload
  }),
  setId: action((state, { id, secret }) => {
    state.id = id
    state.secret = secret
  }),
  setValidated: action((state, payload) => {
    state.validated = payload
  }),
  getByName: computed(state => findName =>
    state.fields.find(({ name }) => name === findName),
  ),
  getErrorByName: computed(state => name =>
    state.validationErrors[name]
      ? state.validationErrors[name]
      : false,
  ),
  updateInputValue: action((state, { name, value }) => {
    state.filledFields[name] = value
  }),
  setInputValue: thunk(async (actions, payload, { getState }) => {
    const { status } = getState()
    actions.updateInputValue(payload)

    if (status !== 'init') {
      const { fields, filledFields } = getState()
      actions.setValidationErrors(validateForm(fields, filledFields))
    }
  }),
  deleteInputValue: action((state, name) => {
    delete state.filledFields[name]
  }),
  setOpenModal: action((state, payload) => {
    state.openModal = payload
  }),
  setOpenModalLeave: action((state, payload) => {
    state.openModalLeave = payload
  }),
  setPopup: action((state, payload) => {
    state.popup = payload
  }),
}
